// extracted by mini-css-extract-plugin
export default {"hideTooltip":"l--z","fadeIn":"m--z","delay":"n--z","recommendedSizeTooltip":"o--z"};